import {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {getProduct, isLegacyNumericProductPath, parseProductIdFromPath} from "@corporatesclub/shared";
import {ProductDetailView} from "@/components/shop/ProductDetailView";

export function ProductPageClient() {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const m = pathname.match(/\/p\/(.+)$/);
  const segment = m?.[1] ? decodeURIComponent(m[1]) : "";
  const id = parseProductIdFromPath(segment);

  useEffect(() => {
    if(!id || !isLegacyNumericProductPath(segment)) return;
    getProduct(id).then((p) => {
      if(p.url && p.url !== pathname) navigate(p.url, {replace: true});
    }).catch(() => {});
  }, [id, segment, pathname, navigate]);

  if(!id) return <p className="notfound">Not found</p>;
  return <ProductDetailView id={id} />;
}
